// R2R Activities Data from Client Process Inputs Spreadsheet
// Source: Spreadsheet tab "Client Process Inputs" columns: Task Group, Activity, Frequency

export interface R2RActivity {
  taskGroup: string
  activityName: string
  frequency: 'Daily' | 'Monthly' | 'Weekly' | 'Quarterly' | 'Annual'
}

export const R2R_ACTIVITIES: R2RActivity[] = [
  // Account Reconciliation Group
  {
    taskGroup: "Account Reconciliation",
    activityName: "Sub-ledger reconciliations, banks recs, production quantities & stock",
    frequency: "Daily"
  },
  {
    taskGroup: "Account Reconciliation",
    activityName: "Balance sheet reconciliation - preparation",
    frequency: "Monthly"
  },
  {
    taskGroup: "Account Reconciliation",
    activityName: "Balance sheet reconciliation - review & approval",
    frequency: "Monthly"
  },
  {
    taskGroup: "Account Reconciliation",
    activityName: "Balance sheet reconciliation - adjustments",
    frequency: "Monthly"
  },


  // Journal Entries Group
  {
    taskGroup: "Journal Entries",
    activityName: "Manual journal entries, adjustments, transfers, error corrections",
    frequency: "Daily"
  },
  {
    taskGroup: "Journal Entries",
    activityName: "Posting corrections and adjustments",
    frequency: "Monthly"
  },

// Reclassifications Group

  {
    taskGroup: "Journal Entries",
    activityName: "Preparation of reclassifications",
    frequency: "Monthly"
  },
  {
    taskGroup: "Journal Entries",
    activityName: "Review & approval of reclassifications",
    frequency: "Monthly"
  },
  {
    taskGroup: "Journal Entries",
    activityName: "Posting of reclassifications",
    frequency: "Monthly"
  },
  // Accruals Group
  {
    taskGroup: "Accruals",
    activityName: "Preparation of accruals & provisions",
    frequency: "Monthly"
  },
  {
    taskGroup: "Accruals",
    activityName: "Review & approval of accruals and provisions",
    frequency: "Monthly"
  },
  {
    taskGroup: "Accruals",
    activityName: "Posting of accruals and provisions",
    frequency: "Monthly"
  },


  // Intercompany Transactions Group
  {
    taskGroup: "Intercompany Transactions",
    activityName: "Transaction postings, cross charges, asset transfer",
    frequency: "Daily"
  },
  {
    taskGroup: "Intercompany Transactions",
    activityName: "Daily Reconciliation and adjustments",
    frequency: "Daily"
  },
  {
    taskGroup: "Intercompany Transactions",
    activityName: "Monthly Reconciliation and adjustments",
    frequency: "Monthly"
  },
  {
    taskGroup: "Intercompany Transactions",
    activityName: "Payments and Settlements",
    frequency: "Monthly"
  },
  // Close Management Group
  {
    taskGroup: "Close Management",
    activityName: "Period open/closing, cost allocation, forex revaluation, depreciation, project and order settlement",
    frequency: "Monthly"
  }
  ]




// Helper functions
export function getTaskGroups(): string[] {
  return [...new Set(R2R_ACTIVITIES.map(activity => activity.taskGroup))]
}

export function getActivitiesByGroup(taskGroup: string): R2RActivity[] {
  return R2R_ACTIVITIES.filter(activity => activity.taskGroup === taskGroup)
}

// export function getAllActivityNames(): string[] {
//   return R2R_ACTIVITIES.map(activity => activity.activityName)
// }

// Regional structure for FTE allocation
export const REGIONS = [
  "North America",
  "EMEA",
  "APAC",
  "India",
  "Shared Services"
] as const

export type Region = typeof REGIONS[number]